var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22L12 21.25L12 22ZM19.4004 17.5505C19.1516 17.8816 19.2183 18.3518 19.5495 18.6006C19.8807 18.8494 20.3508 18.7826 20.5996 18.4515L19.4004 17.5505ZM16.3003 21.8552C16.6798 21.6893 16.8531 21.2472 16.6873 20.8676C16.5214 20.4881 16.0793 20.3148 15.6997 20.4806L16.3003 21.8552ZM22.75 12C22.75 6.06294 17.9371 1.25 12 1.25L12 2.75C17.1086 2.75 21.25 6.89137 21.25 12L22.75 12ZM1.25 12C1.25 17.9371 6.06294 22.75 12 22.75L12 21.25C6.89137 21.25 2.75 17.1086 2.75 12L1.25 12ZM2.75 12C2.75 6.89137 6.89136 2.75 12 2.75L12 1.25C6.06294 1.25 1.25 6.06294 1.25 12L2.75 12ZM20.5996 18.4515C21.9497 16.6546 22.75 14.4197 22.75 12L21.25 12C21.25 14.0836 20.562 16.0044 19.4004 17.5505L20.5996 18.4515ZM12 22.75C13.5275 22.75 14.9824 22.431 16.3003 21.8552L15.6997 20.4806C14.5677 20.9752 13.3169 21.25 12 21.25L12 22.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 8.7998L10.5891 11.317C10.1631 11.7126 10.1631 12.387 10.5891 12.7826L13.3 15.2998",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLeftarrow);
export default __webpack_public_path__ + "static/media/circle-leftarrow.fbc4bf86c505469d8bbd2b1a55725abf.svg";
export { ForwardRef as ReactComponent };